<div class="field-errors-list-component">
  <div class="grid-view-with-filter-column">
    <div class="filter-column-container">
      <!-- Left Column -->
      <left-column class="col-auto left-column"
        [identifiers]="['filter']"
        [icons]="['filter']"
        #lc>
        @if (lc.show === 'filter' || !lc.show) {
          <filter-column
            [listFilter]=listFilter
            [filterConfig]="filterColumnConfig">
          </filter-column>
        }
      </left-column>
      <!-- Left Column end -->
    </div>
    <div class="view-container">
      <div class="filter-tabs-container">
      </div>
      <div class="main-view">
        <div class="grid-card">
          <div class="grid-card-header">
            <div class="d-flex justify-content-between">
              <div class="d-flex justify-content-start scroll-container" style="overflow-x: scroll">
                <filter-tags [filterConfig]="filterColumnConfig" class="d-flex flex-nowrap align-content-center align-items-center flex-grow-1"></filter-tags>
              </div>
              <div class="justify-content-end d-flex flex-row align-items-start ms-2">
                <filter-sorting [listFilter]="listFilter"
                  [filterConfig]="filterColumnConfig"
                ></filter-sorting>
              </div>
            </div>
          </div>
          <div class="grid-card-body">
            <ng-template #table_headers>
              <thead class="table-dark">
                <tr>
                  <th><div>ID</div></th>
                  <th><div><ng-container i18n="@@common.user">User</ng-container> / <ng-container i18="@@common.date">Date</ng-container></div></th>
                  <th><div i18n="@@common.document">Document</div></th>
                  <th><div i18n="@@common.document_type">Document Type</div></th>
                  <th><div i18n="@@common.error_location">Error Location</div></th>
                  <th><div i18n="@@common.workflow_task">Workflow Task</div></th>
                  <th><div i18n="@@common.value">Value</div></th>
                  <th><div i18n="@@common.page_number">Page Number</div></th>
                  <th><div i18n="@@common.coordinates">Coordinates</div></th>
                </tr>
              </thead>
            </ng-template>

            <!-- Result -->
            @if (documentFieldChanges?.getModels().length > 0 && !loading) {
              <div class="table-responsive-new scroll-horizontal">
                <table class="table-new">
                  <ng-template [ngTemplateOutlet]="table_headers"></ng-template>
                  <tbody>
                    @for (fieldChange of documentFieldChanges?.getModels(); track fieldChange) {
                      <tr>
                        <td>
                          <span class="title">#{{ fieldChange.id }}</span>
                        </td>
                        <td>
                          @if (fieldChange.previous_user) {
                            <strong>{{ fieldChange.previous_user?.name }}: </strong>
                          }
                          {{ fieldChange.previous_user_id || fieldChange.user_id }} / {{ (fieldChange.previous_updated_at || fieldChange.updated_at) | pdcDate: { precision: 'm' } }}
                        </td>
                        <td>
                          #{{ fieldChange.document_id }}
                        </td>
                        <td>
                          @if (fieldChange.document_type) {
                            {{ fieldChange.document_type?.title }}
                          }
                        </td>
                        <td>
                          <ng-template #documentSectionTooltip>document_section</ng-template>
                          <ng-template #documentTypeFieldTooltip>document_type_field</ng-template>
                          <ng-template #documentFieldTooltip>document_field</ng-template>
                          <span [tooltip]="documentSectionTooltip" container="body">
                            #{{ fieldChange.document_section_id }}@if (fieldChange.document_section && fieldChange.document_section.document_type_section) {
                            / {{ fieldChange.document_section?.document_type_section?.title }}
                          }
                        </span>
                        <br />
                        <span [tooltip]="documentTypeFieldTooltip" container="body">
                          #{{ fieldChange.document_type_field_id }}@if (fieldChange.document_type_field) {
                          / {{ fieldChange.document_type_field?.title }}
                        }
                      </span>
                      <br />
                      <span [tooltip]="documentFieldTooltip" container="body">
                        #{{ fieldChange.document_field_id }}
                      </span>
                    </td>
                    <td>
                      {{ fieldChange.document_task?.workflow_task }}
                    </td>
                    <td>
                      <div>
                        <strong>
                          <value-diff [current]="fieldChange.value | stringify"
                          [previous]="fieldChange.previous_value | stringify"></value-diff>
                        </strong>
                      </div>
                    </td>
                    <td>
                      <strong>
                        <value-diff [current]="fieldChange.page_number | pageNumber | stringify"
                        [previous]="fieldChange.previous_page_number | pageNumber | stringify"></value-diff>
                      </strong>
                    </td>
                    <td>
                      <div>
                        <strong>
                          <value-diff [current]="fieldChange.coordinates | stringify"
                          [previous]="fieldChange.previous_coordinates | stringify"></value-diff>
                        </strong>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else {
          <div class="table-responsive-new">
            <table class="table-new">
              <ng-template [ngTemplateOutlet]="table_headers"></ng-template>
            </table>
            <div class="alert alert-warning mt-3" role="alert">
              @if (loading) {
                <fa-icon class="me-1" [icon]="['fas', 'sync-alt']" [fixedWidth]="true" animation="spin"></fa-icon>
              }
              @if (loading) {
                <ng-container i18n="@@common.loading_text">We're loading… please wait.</ng-container>
              } @else {
                <ng-container i18n="@@common.nothing_here">There's nothing here!</ng-container>
              }
            </div>
          </div>
        }
        <!-- Result end -->

        <!-- No Result -->
        <!-- No Result end -->
      </div>
      <div class="grid-card-footer">
        @if (documentFieldChanges?.getModels().length > 0) {
          <div>
            <list-pagination
              [totalItems]="documentFieldChanges?.getMeta().meta.stats.total.count"
              [filterComponent]="filterComponent"
              [pageNumber]="listFilter.page.number"
              [pageSize]="listFilter.page.size"
            ></list-pagination>
          </div>
        }
      </div>
    </div>
  </div>
</div>
</div>
</div>
